/*jshint esversion: 6 */

import React from 'react';
import { withTranslation } from "react-i18next";
import CaProfileCompletedQuizzesView from "./CaProfileCompletedQuizzesView";

class CaProfileCompletedQuizzesContainer extends React.Component {

    constructor(props){
        super(props);
    }

    getQuizList() {
        const {quizData,userData} = this.props;
        const quizIds = Object.keys(userData).map(key=>key+"");

        return quizData.filter(quiz=>quizIds.indexOf(quiz.id+"")>-1).map(item=>(
        //return quizData.map(item=>(
            Object.assign(
                {maxPoints:item.question.filter(subitem=>!subitem.is_free_text).length},
                item,
                userData[item.id]
            )
        ));
    }

    render(){
        const quizList = this.getQuizList();
        return(
            <CaProfileCompletedQuizzesView
                completedQuizzes={quizList}
                header={this.props.t('account_page.completed_quizzes.header')}
                body={quizList.length>0?'':this.props.t('account_page.completed_quizzes.body')}
                itemCaption={this.props.t('account_page.completed_quizzes.caption')}

            />
        )
    }
}

export default withTranslation("translations")(CaProfileCompletedQuizzesContainer);




